import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { stockageJetons } from './app/core/services/stockage-jetons';

Amplify.configure({
  Auth: {
    Cognito: {
      // Lu depuis le fichier d'environnement, et non code en dur : sans cela,
      // une bascule d'environnement laisse `main.ts` sur l'ancien pool.
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.clientId
    }
  }
});

// Les jetons ne vont plus dans `localStorage`.
//
// L'ID token y restait en clair, lisible par tout script de la page, par une
// extension du navigateur, et par quiconque copie le profil. Depuis qu'il
// porte les PERMISSIONS, le voler donne l'identite ET les droits.
//
// Desormais : ID et access token en memoire seule, jeton de rafraichissement
// chiffre dans IndexedDB par une clef non extractible. Voir stockage-jetons.ts
// pour ce que cela protege — et ce que cela ne protege pas.
cognitoUserPoolsTokenProvider.setKeyValueStorage(stockageJetons);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
